<div class="list-item">
  <tui-badged-content [style.--tui-radius.%]="50">
    <tui-badge-notification
      *ngIf="getColor() as color"
      tuiSlot="top"
      [size]="'s'"
      [style.background-color]="color"
    ></tui-badge-notification>

    <app-photo
      [size]="'m'"
      [rounded]="true"
      [type]="'photo'"
      [id]="data?.photoId"
      [photoSrc]="data?.photoId ? undefined : '../../../../assets/images/event-default-image.svg'"
      [showPreview]="false"
    ></app-photo>
  </tui-badged-content>

  <div class="list-item__info">
    <div class="header">
      <span class="list-item__text text_size-xs text_color-03">
        {{ data?.dateStart | stringToDate | datePeriod: (data?.dateEnd | stringToDate) }}
      </span>

      <app-badge *ngIf="badgeData" [value]="badgeData.value | translate" [color]="badgeData.color"></app-badge>
    </div>

    <div class="list-item__title">
      <span class="list-item__text text_size-m text_color-01 text_line-2">
        {{ data?.subject }}
      </span>
    </div>

    <div *ngIf="data?.address" class="address list-item__text text_size-xs text_color-03 text_truncate">
      <app-icon [src]="'map-pin'" [size]="'15px'"></app-icon>
      {{ data?.address }}
    </div>
  </div>
</div>
